import React, { useState, useRef } from 'react';

import SettingsSection from './SettingsSection.jsx';

import PTWTable from '../components/PTWTable.jsx';
import SubcontractedEvents from '../components/SubcontractedEvents.jsx';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';

import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/PrintOutlined';

import { useReactToPrint } from 'react-to-print';
import { PTWDefaultState, PTWContext } from './context/PTWContext.js';

import get from 'lodash.get';

const tabTypes = {
	SettingsSection,
	PTWTable,
	SubcontractedEvents,
};

const PTWSection = ({
	Registry,
	tabs = [],
	values,
	errors, 
	onChange,
	readOnly,
	disabled,
	printHeader,
}) => {
	const [selectedTab, setSelectedTab] = useState(0);
	const [showPrintView, setPrintView] = useState(false);

	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const tabsVisible = tabs.filter(tab => {
		if(!tab.visible) return true;
		const isExpression = tab.visible.includes('exp:');
		if(!isExpression) return get(values, tab.visible);
		const f = new Function('values', 'isPrinting', `return ${tab.visible.replace('exp:', '')}`);
		return f(values, showPrintView);
	});

	const getTab = tab => {
		const { type } = tab;
		const props = { Registry, values, errors, onChange, readOnly, disabled };
		const Tab = tabTypes[type];
		if(!type || !Tab) return <SettingsSection padding={2} {...props} {...tab} />;
		return <Tab {...props} {...tab} />;
	};

	const currentTab = tabsVisible[selectedTab];

	const currentState = {
		...PTWDefaultState,
		isPrinting: showPrintView,
	};

	return (
		<PTWContext.Provider value={currentState}>
			<Box sx={{ maxWidth: '100%', height: '100%', display: 'flex', flexDirection: 'row' }}>
				<Tabs
					orientation="vertical"
					variant="scrollable"
					value={selectedTab}
					onChange={(e, v) => setSelectedTab(v)}
					sx={{ width: 200, flexGrow: 0 }}
				>
					{tabsVisible.map(tab => 
						<Tab
							key={tab.label}
							sx={{ textAlign: 'right', alignItems: 'end', backgroundColor: tab.color }} 
							label={tab.label} 
						/>)}
					<Button sx={{ marginTop: 5 }} onClick={() => setPrintView(true)}><PrintIcon /></Button>
				</Tabs>
			
				<Box sx={{ width: '100%', flexGrow: 1, borderLeft: 1, borderColor: 'divider' }}>
					{getTab(currentTab)}
				</Box>

				<Dialog open={showPrintView} fullScreen>
					<Box sx={{ display: 'flex', flexDirection: 'row', padding: 2 }}>
						<Button onClick={() => setPrintView(false)}><CloseIcon /></Button>
						{/* <Box sx={{ flexGrow: 1 }} /> */}
						<Alert severity='info' sx={{ flexGrow: 1 }}>For best results, adjust the print settings. Papersize: A4. Orientation: Landscape. Scale: 50%</Alert>

						<Button onClick={handlePrint}><PrintIcon /></Button>
					</Box>

					<Box ref={componentRef} sx={{
						padding: 2,
						backgroundColor: 'white',
					}}>
						{printHeader}
						{showPrintView && tabsVisible.map(tab => 
							<Box key={tab.label}>
								<Typography variant="h6" sx={{ marginTop: 2, marginBottom: 2, padding: 1, backgroundColor: 'primary.main', color: 'background.default' }}>{tab.label}</Typography>
								{getTab(tab)}
							</Box>,
						)}
					</Box>
				</Dialog>
			</Box>
		</PTWContext.Provider>
	);
};

PTWSection.type = 'PTWSection';
PTWSection.hasNavigation = true;

export default PTWSection;